import { Box, Paper } from "@mui/material";
import React, { useContext, useState } from "react";
import { Accordion, Alert } from "../../../../layout";
import { CartContext } from "../POS";
import SelectCustomer from "./SelectCustomer";
import CartProdHeader from "./CartProdHeader";
import CartProdBody from "./CartProdBody";
import Accounts from "./Accounts";
import CartAdditionalFields from "./CartAdditionalFields";
import ParkSale from "../ParkAndRetiveSale/ParkSale";
import { useFormatPrice } from "hooks";

const Cart = () => {
  const formatPrice = useFormatPrice();
  const { cartData } = useContext(CartContext);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  return (
    <>
      <div className="flex items-center gap-2 mb-[7px]">
        <SelectCustomer />
        <ParkSale />
      </div>

      <Paper className="!rounded-[20px] bg-white pt-[10px]">
        {/* Cart Items */}
        <Box
          sx={{
            height: "calc(100vh - 310px)",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Accordion
            items={cartData.sellItems.map((item, i) => ({
              header: <CartProdHeader item={item} />,
              body: <CartProdBody {...{ item, setAlert }} />,
            }))}
          />

          <div className="w-[100%]">
            <Accordion
              items={[
                {
                  header: (
                    <div className="text-gray-500 w-[100%] uppercase flex justify-between">
                      <span className="text-[16px] font-medium">Add</span>
                      <span className="mr-10">
                        Note & Discount{" "}
                        {cartData.disAmt > 0 && (
                          <span className="font-semibold">
                            {formatPrice(cartData.disAmt)}
                          </span>
                        )}
                      </span>
                    </div>
                  ),
                  body: <CartAdditionalFields />,
                },
              ]}
            />
          </div>
        </Box>

        {/* Accounts */}
        <Accounts />
      </Paper>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Cart;
